module.exports = __webpack_public_path__ + "img/aston-university-online-thumb.bce506f8.jpg";